module.exports = __webpack_public_path__ + "static/media/csv.5e6a87d7.svg";